<div class="wysiwyg-extended">
    <quill-editor 
        *ngIf="editorModules != null"
        [modules]="editorModules"
        [placeholder]="placeholder"
        (onEditorChanged)="changedEditor($event)" 
        (onEditorCreated)="created($event)"
        (dragover)="false"
    ></quill-editor>
</div>
